import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.css";
import "../help/FAQ.css";
import { Link, useLocation } from "react-router-dom";

const SUPPORTED_LOCALES = new Set(["en", "fr", "en-US", "fr-CA"]);

const FAQ = ({ isFAQOpen }) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const location = useLocation();

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const currentLanguage = location.pathname.split("/")[1];
  const localizedHomePath = SUPPORTED_LOCALES.has(currentLanguage)
    ? `/${currentLanguage}`
    : "/";

  const faqs = [
    {
      question: t("faq.question1"),
      answer: (
        <>
          {t("faq.answer1")}
          {/* <div className="faq-image-container">
            <img
              src="/assets/faq/clear_image_example.png"
              alt="Exemple d'image claire"
              className="faq-image"
            />
            <p className="faq-caption">
              {t("faq.captionExample1", "Exemple d'une image claire pour une détection optimale.")}
            </p>
          </div> */}
        </>
      ),
    },
    {
      question: t("faq.question2"),
      answer: (
        <Trans
          i18nKey="faq.answer2WithLink"
          components={{
            pricingLink: (
              <Link
                to={{ pathname: localizedHomePath, hash: "#pricing" }}
                className="faq-answer-link"
                onClick={(event) => event.stopPropagation()}
              />
            ),
          }}
        />
      ),
    },
    {
      question: t("faq.question3"),
      answer: t("faq.answer3"),
    },
    {
      question: t("faq.question4"),
      answer: t("faq.answer4"),
    },
  ];

  return (
    <div className="faq-container">
      <h2>{t("faq.title")}</h2>
      <p>{t("faq.intro")}</p>
      <div className="faq-accordion">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleAccordion(index)}
          >
            <h4 className="faq-question">{faq.question}</h4>
            {activeIndex === index && <div className="faq-answer">{faq.answer}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
